import * as array from 'd3-array'
import * as d3 from 'd3-selection'

import animations from './animations'

export {animations}

const byLongestValue = (point) => {
  let value = point.formatted && point.formatted.value
  return (value || '').length
}

const byLongestTitle = (point, serie) => {
  let value = (point.formatted && point.formatted.value) || ''
    , title = (point.formatted && point.formatted.title) || ''

  if (serie.stackBy) {
    // The title is combined with the value for stack by bars
    if (title.length) {
      title += ' ' // Add the space
    }
    title += value
  }

  return title.length
}

const getLongest = (plots, lengthDeterminer) => {
  return array.max(plots, plot => {
    return array.max(plot.series, serie => {
      return array.max(serie.points, point => {
        return lengthDeterminer(point, serie)
      })
    })
  })
}


const getTextBB = (svg, text) => {
  return bb
}

export const preAnimate = function (chart, selection, series) {
  // Determine if any labels in the entire chart don't fit within the
  // width of a bar. If so, we use a vertical layout. We have to grab
  // the longest label in ALL plots.
  let longestValue = getLongest(chart.layout.plots, byLongestValue)
    , longestTitle = getLongest(chart.layout.plots, byLongestTitle)
    , showingTitle = !!longestTitle
    , node = d3.select(selection.node().ownerSVGElement)
               .append('text')
               .text(Array(longestValue).fill('0').join('')) // Create string with same number of characters
    , valueBB = node.node().getBBox()

  // Now get the title bounding box
  node.text(Array(longestTitle).fill('0').join('')) // Create string with same number of characters
  let titleBB = node.node().getBBox()

  node.remove() // Placeholder can be removed

  return {
    labelsConfig: {
      showingTitle,
      longestTitleBB: titleBB,
      longestValueBB: valueBB, // Store so bar decorations have access
    }
  }

}
